/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import i18next from 'i18next';

import { dropLastCharacter, dropNCharacters, getFirstWordFrom } from '~utils/string';
import { API_ERRORS } from '~constants/apiErrors';

const notAuthorizedMessage = (key) => `${i18next.t('Errors:not_authorized')}: api/v1/${key}/`;
const getUnauthorizedLength = (key) => notAuthorizedMessage(key).length;

const mapPoliciesError = (description) => {
  const isAdmin = description.includes('admin');
  const droppedError = dropNCharacters(getUnauthorizedLength(isAdmin ? 'admin' : 'kds'))(description);
  const formattedObject = getFirstWordFrom(droppedError);
  const object = i18next.t(`PoliciesErrors:${formattedObject}`);
  const formattedAction = dropNCharacters(formattedObject.length + 1)(
    dropLastCharacter(droppedError)
  ).toLowerCase();
  const action = i18next.t(`PoliciesErrors:${formattedAction}`);

  return i18next.t('PoliciesErrors:carryOutAction', { action, object });
};

const mapFieldsValidationError = (error) => i18next.t(`Errors:${error.fields?.[0]?.name}`);
const TOAST_DURATION = 7000;

export const errorsMapper = {
  [API_ERRORS.NOT_AUTHORIZED]: mapPoliciesError,
  [API_ERRORS.FIELDS_VALIDATION]: mapFieldsValidationError
};

export const handleAPIErrors = ({ data }) => {
  const code = data?.code;
  return (
    code &&
    toast.error(errorsMapper[code]?.(data) || data.message, {
      autoClose: TOAST_DURATION
    })
  );
};
